import * as React from 'react';
import NotificationDisplay from '../NotificationDisplay/NotificationDisplay';
import AppLayoutContextUpdater from '../../Common/AppLayoutContextUpdater/AppLayoutContextUpdater';
import { WindowWrapper } from 'login-utils/globalWrappers';
import * as _ from 'lodash';

class ActivationExpired extends React.Component<{}, {}> {
  render() {
    const orgConfig = WindowWrapper.DEPLOYMENT_CONFIG.organization;

    const expiredMsg = `Your activation link has expired. Please contact ${orgConfig.name} to reset your account.`;
    const noContactMessage = 'Activation link expired';
    const contactMessage = 'Your activation link has expired. Please contact us to receive a new link.';
    const title = 'Application Link Expired';
    // TODO: this is also being used in ResentActivation, consider moving getSupportEmail function to utils.
    const supportEmail = _.find(
      orgConfig.notificationDetails,
      notificationDetail => notificationDetail.senderEmailIdType === 'SUPPORT',
    );
    const supportEmailAddress = supportEmail ? supportEmail.senderEmailId : '';

    return (
      <div className="ActivationExpired">
        <AppLayoutContextUpdater
          appTitle={supportEmail ? noContactMessage : contactMessage}
          footerConfig={null}
          appDocumentTitle={title}
        >
          {!!supportEmailAddress && (
            <NotificationDisplay
              message={expiredMsg}
              emailSubject="Account activation link expired"
              supportEmail={supportEmailAddress}
              orgName={orgConfig.name}
            />
          )}
        </AppLayoutContextUpdater>
      </div>
    );
  }
}

export default ActivationExpired;
